import { Text } from "@fluentui/react/lib/Text";

import { WithConfiguration } from "Components/Generic/Configuration";
import { WithTranslator } from "Components/Generic/Translator";
import { getFormattedValue } from "Utils/Field";
import { isCurrencyField, isImageListField, isUrlListField } from "Utils/Metadata";
import { ImageListValue } from "./ImageListValue";
import { IValueProps } from "./IValueProps";
import { MoneyValue } from "./MoneyValue";
import { UrlListValue } from "./UrlListValue";

export const Value = WithConfiguration(
  WithTranslator((props: IValueProps): JSX.Element => {
    const { item, placeholder, translator } = props;

    if (item == null) {
      return <Text variant="smallPlus">{placeholder}</Text>;
    }

    if (isCurrencyField(props)) {
      return <MoneyValue {...props} />;
    }

    if (isImageListField(props)) {
      return <ImageListValue {...props} />;
    }

    if (isUrlListField(props)) {
      return <UrlListValue {...props} />;
    }

    return <Text>{getFormattedValue(item, props, translator, placeholder)}</Text>;
  })
);
